import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/leaderboard/page.tsx");
